import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Edit({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'20px'} height={'20px'} viewBox={'0 0 20 20'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-2.000000, -2.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M16,4.41421356 L4,16.4142136 L4,20 L7.58578644,20 L19.5857864,8 L16,4.41421356 Z M16.7071068,2.29289322 L21.7071068,7.29289322 C22.0976311,7.68341751 22.0976311,8.31658249 21.7071068,8.70710678 L8.70710678,21.7071068 C8.5195704,21.8946432 8.26521649,22 8,22 L3,22 C2.44771525,22 2,21.5522847 2,21 L2,16 C2,15.7347835 2.10535684,15.4804296 2.29289322,15.2928932 L15.2928932,2.29289322 C15.6834175,1.90236893 16.3165825,1.90236893 16.7071068,2.29289322 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Edit.propTypes = {
  className: PropTypes.string,
}
